import history from '../../hashHistory';
import { QueryParams } from './queryParams.types';

export const deleteQueryParam = <T extends keyof QueryParams>(param: T) => {
  const urlParams = new URLSearchParams(history.location.search);
  urlParams.delete(param);
  history.location.search = urlParams.toString();
};
